import { useState } from "react";
import { toast } from "react-toastify";
import useLoader from "../../../hooks/useLoader.js";
import useModal from "../../../hooks/useModal.js";
import { PAY_BASIS_OPTIONS, updatePayBasis } from "../../../services/payBasis.js";

// If an employee is being moved off MONTHLY, the Wage Rates tab is where
// the actual rate for their new pay basis gets configured - this just
// changes the flag on the employee record.
const AddEditPayBasis = ({ refresh, existingField }) => {
  const { showLoader, hideLoader } = useLoader();
  const { hideModal } = useModal();
  const [payBasis, setPayBasis] = useState(existingField?.pay_basis || "MONTHLY");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    showLoader();

    try {
      const response = await updatePayBasis(existingField.employee_id, payBasis);
      toast.success(response?.data?.message || "Pay basis updated successfully!");
      refresh?.();
      hideModal?.();
    } catch (error) {
      console.error("Error updating pay basis:", error);
      toast.error(error?.response?.data?.message || "Failed to update pay basis");
    } finally {
      setIsSubmitting(false);
      hideLoader();
    }
  };

  return (
    <div style={{ marginTop: "10px" }}>
      <div className="mb-3">
        <label className="form-label" style={{ fontWeight: 600, fontSize: "12px" }}>
          Employee
        </label>
        <div className="form-control form-control-sm bg-light" style={{ pointerEvents: "none" }}>
          {existingField?.employee_name} {existingField?.employee_code ? `(${existingField.employee_code})` : ""}
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label" style={{ fontWeight: 600, fontSize: "12px" }}>
          Pay Basis <span className="text-danger">*</span>
        </label>
        <select
          className="form-select form-select-sm"
          value={payBasis}
          onChange={(e) => setPayBasis(e.target.value)}
          disabled={isSubmitting}
        >
          {PAY_BASIS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {payBasis !== "MONTHLY" && (
          <div className="form-text">
            Make sure an active wage rate exists for this employee under the Wage Rates tab.
          </div>
        )}
      </div>

      <div className="d-flex justify-content-end gap-2" style={{ borderTop: "1px solid #e0e0e0", paddingTop: "12px" }}>
        <button type="button" onClick={hideModal} className="btn btn-secondary btn-sm" disabled={isSubmitting}>
          Cancel
        </button>
        <button type="button" className="btn btn-success btn-sm" disabled={isSubmitting} onClick={handleSubmit}>
          {isSubmitting ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AddEditPayBasis;
